module.exports = __webpack_public_path__ + "static/fassadenschnitt_mini-94dedba318845d05d196e47432b37826.png";